const iconClass = 'h-3.5 w-3.5'

const iconButtonClass =
  'flex h-7 w-7 shrink-0 items-center justify-center text-text-primary transition-opacity hover:opacity-70'

export const PlayerIconButton = ({
  label,
  onClick,
  children,
  className = '',
  disabled = false,
  ...rest
}) => (
  <button
    type="button"
    className={[
      iconButtonClass,
      disabled && rest['data-loading'] !== 'true' ? 'cursor-not-allowed opacity-40' : '',
      className,
    ].join(' ')}
    aria-label={label}
    onClick={onClick}
    disabled={disabled}
    {...rest}
  >
    {children}
  </button>
)

export const IconPrevious = () => (
  <svg viewBox="0 0 16 16" className={iconClass} aria-hidden="true" fill="currentColor">
    <path d="M3 3v10h1.5V3H3zM11 3L3 8l8 5V3z" />
  </svg>
)

export const IconNext = () => (
  <svg viewBox="0 0 16 16" className={iconClass} aria-hidden="true" fill="currentColor">
    <path d="M5 3l8 5-8 5V3zM11.5 3v10H13V3h-1.5z" />
  </svg>
)

export const IconPlay = () => (
  <svg viewBox="0 0 16 16" className={iconClass} aria-hidden="true" fill="currentColor">
    <path d="M4 2.5v11l9-5.5-9-5.5z" />
  </svg>
)

export const IconPause = () => (
  <svg viewBox="0 0 16 16" className={iconClass} aria-hidden="true" fill="currentColor">
    <path d="M4 2.5h2.5v11H4v-11zm5.5 0H12v11H9.5v-11z" />
  </svg>
)

export const IconStop = () => (
  <svg viewBox="0 0 16 16" className="h-4 w-4" aria-hidden="true">
    <rect x="3.5" y="3.5" width="9" height="9" fill="#d94848" />
  </svg>
)

export const IconSpotify = () => (
  <svg viewBox="0 0 16 16" className={iconClass} aria-hidden="true" fill="currentColor">
    <path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm2.8 9.1c-.1.2-.4.2-.6.1-1.6-.9-3.6-1.1-5.9-.6-.2 0-.4-.1-.5-.3s-.1-.4.1-.5c2.5-.6 4.8-.3 6.7.7.2.1.3.4.2.6zm1.2-2.7c-.2.2-.5.3-.8.1-1.9-1.1-4.7-1.4-6.9-.8-.3.1-.6-.1-.7-.4-.1-.3.1-.6.4-.7 2.5-.7 5.6-.4 7.9 1 .3.2.4.5.2.8zm.2-2.8c-.2.3-.6.3-.9.1-2.1-1.3-5.4-1.7-7.9-.9-.4.1-.7-.2-.8-.5-.1-.4.2-.7.6-.8 2.9-.9 6.6-.4 9.1 1.1.3.2.4.6.1.9z" />
  </svg>
)

export const IconLoading = () => (
  <svg viewBox="0 0 16 16" className={`${iconClass} animate-pulse`} aria-hidden="true" fill="currentColor">
    <circle cx="8" cy="8" r="1.5" />
  </svg>
)

export const IconVolume = () => (
  <svg viewBox="0 0 16 16" className={iconClass} aria-hidden="true" fill="none">
    <path
      d="M3 5.75h1.75L8 3.25v9.5L4.75 10.25H3V5.75z"
      fill="currentColor"
    />
    <path
      d="M9 7Q10.5 8 9 9"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M10.25 5.5Q12.5 8 10.25 10.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
)

export const IconVolumeMuted = () => (
  <svg viewBox="0 0 16 16" className={iconClass} aria-hidden="true" fill="none">
    <path
      d="M3 5.75h1.75L8 3.25v9.5L4.75 10.25H3V5.75z"
      fill="currentColor"
    />
    <path
      d="M10.25 5.75 13.75 9.25"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M13.75 5.75 10.25 9.25"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
)
